<template>
    <div class="lang arabic">
        <div class="info">
            <h3 class="bullet01">خدمات العيادات الخارجية (للمرضى الأجانب الذين يمتلكون أو لا يمتلكون التأمين الصحي الوطني الكوري)</h3>
            <ul class="step-box">
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الأولى</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">حدد موعداً</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثانية</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">قم بزيارة المركز الدولي للرعاية الصحية.</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الثالثة.</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">استشر طبيبك</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة 4</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">استكمال الدفع</h4>
                    </div>
                </li>
                <li class="step-box__item"><span class="step-box__item--step">الخطوة الخامسة</span>
                    <div class="step-box__item__top">
                        <h4 class="title03">استمر في إجراء الفحص أو أخذ الوصفة الطبية</h4>
                    </div>
                </li>
            </ul>
            <h4 class="depth bullet02 mt20">حدد موعداً</h4>
            <p class="depth">
                اتصل بنا على +82-6986-3100
                <br>
                البريد الإلكتروني على Eumcint@Gmail.com
                <br>
                تقديم الطلب عبر الإنترنت عند طلب موعد
                <br>
                قم بزيارة عيادتنا (يرجى ملاحظة أن الموعد قد لا يكون ممكنا في اليوم نفسه.)
            </p>
            <h4 class="depth bullet02">قم بزيارة المركز الدولي للرعاية الصحية.</h4>
            <p class="depth">
                قم بزيارة المركز الدولي للرعاية الصحية في الطابق الأول. سيُطلب منك إحضار بطاقة الصليب الأحمر الخاص بك أو جواز السفر لتسجيل المريض. إذا كان لديك سجلات طبية، أو نتائج اختبار، أو صور قرص مضغوط، فيرجى الوصول مبكراً 10 دقائق لإرسال المادة. يمكنك زيارة الطبيب الذي تم تعيينه لك باستخدام رقم تعريف المستشفى الخاص بك.
            </p>
            <h4 class="depth bullet02">استشر طبيبك</h4>
            <p class="depth">
                سيناقش طبيبك خطة رعايتك وسوف يحيلك إلى أخصائي آخر إذا لزم الأمر. سوف تساعدك ممرضة أو منسقة المركز الدولي للرعاية الصحية عند تحديد موعد الاختبارات التشخيصية أو مواعيد المتابعة.
            </p>
            <h4 class="depth bullet02">استكمال الدفع</h4>
            <p class="depth">
                يمكن دفع رسوم العلاج نقدا (الون الكوري) أو ببطاقة الائتمان. إذا كنت تحتاج إلى خدمات صرف العملات الأجنبية، فإن البنك الموجود في B1 من المبنى الرئيسي يمكنه تقديم المساعدة. وفقا لسياسة المستشفى، يجب دفع جميع فحوصات العيادات الخارجية والعلاجات وكذلك الاستشارة قبل الموعد. يرجى إحضار نماذج التأمين الدولية معك إذا طلب منك تقديمها إلى شركة التأمين.
            </p>
            <h4 class="depth bullet02">استمر في إجراء الفحص أو أخذ الوصفة الطبية</h4>
            <p class="depth">
                بمجرد أن تتم عملية الدفع، يمكنك متابعة الفحوصات المجدولة حسب الحاجة. يرجى طباعة الوصفة الطبية الخاصة بك والانتقال إلى الصيدلية للحصول عليها.
            </p>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>